import React, { ReactNode } from 'react';
import styles from './Navigation.module.css';

export const Navigation = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <nav className={styles.navigation}>
    <h1 className={styles.header}>{title}</h1>
    <div className={styles.children}>{children}</div>
  </nav>
);
